// Accessibility - done in DO-2507
import * as React from 'react';

import Text, { TextProps } from './text';

export interface TypographyProps extends TextProps {}

export const Display1: React.FC<Omit<TextProps, 'size' | 'weight'>> = ({
    children,
    tag,
    align,
    color,
    inline,
    ellipsis,
    breakWords,
    dangerous = true,
    a11y,
    dataQA,
    extraClass,
}) => (
    <Text
        size="display-1"
        tag={tag}
        align={align}
        color={color}
        inline={inline}
        ellipsis={ellipsis}
        breakWords={breakWords}
        dangerous={dangerous}
        a11y={a11y}
        dataQA={dataQA}
        extraClass={extraClass}
    >
        {children}
    </Text>
);

export const Display2: React.FC<Omit<TextProps, 'size' | 'weight'>> = ({
    children,
    tag,
    align,
    color,
    inline,
    ellipsis,
    breakWords,
    dangerous = true,
    a11y,
    dataQA,
    extraClass,
}) => (
    <Text
        size="display-2"
        tag={tag}
        align={align}
        color={color}
        inline={inline}
        ellipsis={ellipsis}
        breakWords={breakWords}
        dangerous={dangerous}
        a11y={a11y}
        dataQA={dataQA}
        extraClass={extraClass}
    >
        {children}
    </Text>
);

export const Display3: React.FC<Omit<TextProps, 'size' | 'weight'>> = ({
    children,
    tag,
    align,
    color,
    inline,
    ellipsis,
    breakWords,
    dangerous,
    a11y,
    dataQA,
    extraClass,
}) => (
    <Text
        size="display-3"
        tag={tag}
        align={align}
        color={color}
        inline={inline}
        ellipsis={ellipsis}
        breakWords={breakWords}
        dangerous={dangerous}
        a11y={a11y}
        dataQA={dataQA}
        extraClass={extraClass}
    >
        {children}
    </Text>
);

export const Header1: React.FC<Omit<TextProps, 'size' | 'weight'>> = ({
    children,
    tag,
    align,
    color,
    inline,
    ellipsis,
    breakWords,
    dangerous,
    a11y,
    dataQA,
}) => (
    <Text
        size="header-1"
        tag={tag}
        align={align}
        color={color}
        inline={inline}
        ellipsis={ellipsis}
        breakWords={breakWords}
        dangerous={dangerous}
        a11y={a11y}
        dataQA={dataQA}
    >
        {children}
    </Text>
);

export const Header2: React.FC<Omit<TextProps, 'size' | 'weight'>> = ({
    children,
    tag,
    align,
    color,
    inline,
    ellipsis,
    breakWords,
    dangerous,
    a11y,
    dataQA,
}) => (
    <Text
        size="header-2"
        tag={tag}
        align={align}
        color={color}
        inline={inline}
        ellipsis={ellipsis}
        breakWords={breakWords}
        dangerous={dangerous}
        a11y={a11y}
        dataQA={dataQA}
    >
        {children}
    </Text>
);

export const Header3: React.FC<Omit<TextProps, 'size' | 'weight'>> = ({
    children,
    tag,
    align,
    color,
    inline,
    ellipsis,
    breakWords,
    dangerous,
    a11y,
    dataQA,
}) => (
    <Text
        size="header-3"
        tag={tag}
        align={align}
        color={color}
        inline={inline}
        ellipsis={ellipsis}
        breakWords={breakWords}
        dangerous={dangerous}
        a11y={a11y}
        dataQA={dataQA}
    >
        {children}
    </Text>
);

export const Header4: React.FC<Omit<TextProps, 'size' | 'weight'>> = ({
    children,
    tag,
    align,
    color,
    inline,
    ellipsis,
    breakWords,
    dangerous,
    a11y,
    dataQA,
}) => (
    <Text
        size="header-4"
        tag={tag}
        align={align}
        color={color}
        inline={inline}
        ellipsis={ellipsis}
        breakWords={breakWords}
        dangerous={dangerous}
        a11y={a11y}
        dataQA={dataQA}
    >
        {children}
    </Text>
);

export const Action: React.FC<
    Pick<TextProps, 'children' | 'tag' | 'inline' | 'breakWords' | 'dangerous' | 'a11y' | 'dataQA'>
> = ({ children, tag, inline, breakWords, dangerous, a11y, dataQA }) => (
    <Text
        size="action"
        tag={tag}
        inline={inline}
        breakWords={breakWords}
        dangerous={dangerous}
        a11y={a11y}
        dataQA={dataQA}
    >
        {children}
    </Text>
);

export const ActionSmall: React.FC<
    Pick<TextProps, 'children' | 'tag' | 'inline' | 'breakWords' | 'dangerous' | 'a11y' | 'dataQA'>
> = ({ children, tag, inline, breakWords, dangerous, a11y, dataQA }) => (
    <Text
        size="action-small"
        tag={tag}
        inline={inline}
        breakWords={breakWords}
        dangerous={dangerous}
        a11y={a11y}
        dataQA={dataQA}
    >
        {children}
    </Text>
);

export const ActionMini: React.FC<
    Pick<TextProps, 'children' | 'tag' | 'inline' | 'breakWords' | 'dangerous' | 'a11y' | 'dataQA'>
> = ({ children, tag, inline, breakWords, dangerous, a11y, dataQA }) => (
    <Text
        size="action-mini"
        tag={tag}
        inline={inline}
        breakWords={breakWords}
        dangerous={dangerous}
        a11y={a11y}
        dataQA={dataQA}
    >
        {children}
    </Text>
);

export const Title: React.FC<Omit<TextProps, 'size' | 'weight'>> = ({
    children,
    tag,
    align,
    color,
    inline,
    ellipsis,
    breakWords,
    dangerous,
    a11y,
    dataQA,
}) => (
    <Text
        size="p-title"
        tag={tag}
        align={align}
        color={color}
        inline={inline}
        ellipsis={ellipsis}
        breakWords={breakWords}
        dangerous={dangerous}
        a11y={a11y}
        dataQA={dataQA}
    >
        {children}
    </Text>
);

interface PProps extends Omit<TextProps, 'size' | 'weight'> {
    weight?: 'default' | 'bolder';
}

export const P1: React.FC<PProps> = ({
    children,
    tag,
    weight,
    align,
    color,
    inline,
    ellipsis,
    breakWords,
    dangerous = true,
    a11y,
    dataQA,
    extraClass,
}) => (
    <Text
        size="p-1"
        tag={tag}
        weight={weight === 'bolder' ? 'medium' : 'regular'}
        align={align}
        color={color}
        inline={inline}
        ellipsis={ellipsis}
        breakWords={breakWords}
        dangerous={dangerous}
        a11y={a11y}
        dataQA={dataQA}
        extraClass={extraClass}
    >
        {children}
    </Text>
);

export const P2: React.FC<PProps> = ({
    children,
    tag,
    weight,
    align,
    color,
    inline,
    ellipsis,
    breakWords,
    dangerous,
    a11y,
    dataQA,
    onClick,
}) => (
    <Text
        size="p-2"
        tag={tag}
        weight={weight === 'bolder' ? 'semibold' : 'regular'}
        align={align}
        color={color}
        inline={inline}
        ellipsis={ellipsis}
        breakWords={breakWords}
        dangerous={dangerous}
        a11y={a11y}
        dataQA={dataQA}
        onClick={onClick}
    >
        {children}
    </Text>
);

export const P3: React.FC<PProps> = ({
    children,
    tag,
    weight,
    align,
    color,
    inline,
    ellipsis,
    breakWords,
    dangerous,
    a11y,
    dataQA,
    extraClass,
}) => (
    <Text
        size="p-3"
        tag={tag}
        weight={weight === 'bolder' ? 'bold' : 'medium'}
        align={align}
        color={color}
        inline={inline}
        ellipsis={ellipsis}
        breakWords={breakWords}
        dangerous={dangerous}
        a11y={a11y}
        dataQA={dataQA}
        extraClass={extraClass}
    >
        {children}
    </Text>
);

export default {
    Display1,
    Display2,
    Display3,
    Header1,
    Header2,
    Header3,
    Header4,
    Action,
    ActionSmall,
    ActionMini,
    Title,
    P1,
    P2,
    P3,
};
